const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

/** Compute a human-readable accounting period label from a date string and recurrence pattern. */
export function computePeriodLabel(dateStr: string, pattern: string): string {
  const d = new Date(dateStr + "T12:00:00");
  if (isNaN(d.getTime())) return dateStr;

  if (pattern === "weekly" || pattern === "bi-weekly") {
    const spanDays = pattern === "bi-weekly" ? 13 : 6;
    const lastDay = new Date(d);
    lastDay.setDate(d.getDate() + spanDays);
    return d.getMonth() === lastDay.getMonth()
      ? `${MONTHS[d.getMonth()]} ${d.getDate()} – ${lastDay.getDate()}`
      : `${MONTHS[d.getMonth()]} ${d.getDate()} – ${MONTHS[lastDay.getMonth()]} ${lastDay.getDate()}`;
  }
  if (pattern === "quarterly") {
    const q = Math.floor(d.getMonth() / 3) + 1;
    return `Q${q} '${d.getFullYear().toString().slice(-2)}`;
  }
  if (pattern === "yearly" || pattern === "annually") {
    const yy = d.getFullYear().toString().slice(-2);
    return `Jan '${yy} – Dec '${yy}`;
  }
  return `${MONTHS[d.getMonth()]} '${d.getFullYear().toString().slice(-2)}`;
}

// Per-type badge Tailwind classes — explicit strings so Tailwind doesn't purge them
export const projectTypeBadgeClasses: Record<string, string> = {
  "1040":                 "bg-blue-100 text-blue-800 border border-blue-300",
  "1120S":                "bg-indigo-100 text-indigo-800 border border-indigo-300",
  "1065":                 "bg-purple-100 text-purple-800 border border-purple-300",
  "1120":                 "bg-cyan-100 text-cyan-800 border border-cyan-300",
  "1041":                 "bg-teal-100 text-teal-800 border border-teal-300",
  "990":                  "bg-orange-100 text-orange-800 border border-orange-300",
  "Bookkeeping":          "bg-emerald-100 text-emerald-800 border border-emerald-300",
  "Financial Statements": "bg-sky-100 text-sky-800 border border-sky-300",
  "Property Tax":         "bg-amber-100 text-amber-800 border border-amber-300",
  "Sales Tax":            "bg-yellow-100 text-yellow-800 border border-yellow-300",
  "Payroll":              "bg-rose-100 text-rose-800 border border-rose-300",
  "Advisory":             "bg-violet-100 text-violet-800 border border-violet-300",
  "Tax Planning":         "bg-blue-50 text-blue-700 border border-blue-200",
  "1099":                 "bg-slate-100 text-slate-700 border border-slate-300",
  "Other":                "bg-gray-100 text-gray-700 border border-gray-300",
};
